import { post } from './http'
import global from '@/api/global'
var name = global.signature
var name2 = global.orderName
var payName = global.payName

// 查询人员结构树
export const selectPersonnelTree = p => post(`/${name}/cFlowNode/selectPersonnelTree`, p)
// 新增流程
export const flowAdd = p => post(`/${name}/cFlow/add`, p)
// 流程列表
export const flowList = p => post(`/${name}/cFlow/flowList`, p)
// 流程列表新
export const flowListNew = p => post(`/${name}/cFlow/flowListNew`, p)
// 启用停用
export const isUse = p => post(`/${name}/cFlow/isUse`, p)
// 删除流程
export const cFlowDel = p => post(`/${name}/cFlow/delete`, p)
// 编辑流程跳转
export const updateDetail = p => post(`/${name}/cFlow/updateDetail`, p)
// 删除节点
export const CFNdel = p => post(`/${name}/cFlowNode/delete`, p)
// 删除节点上的人员（平）
export const cFlowNodeUserDel = p => post(`/${name}/cFlowNodeUser/delete`, p)
// 编辑流程跳转
export const updateCFlow = p => post(`/${name}/cFlow/updateCFlow`, p)
// 所在仓库列表
export const warehouseList = p => post(`/${name}/cFlow/warehouseList`, p)
// 查看签章日志
export const signatureLogList = p => post(`/${name}/signatureLog/list`, p)
// 合同管理
export const findContractBypList = p => post(`/${name}/contract/findContractBypList`, p)// 列表
export const getContractPdfForBusinessNo = p => post(`/${name}/api/contractSignature/getContractPdfForBusinessNo`, p) // 查看pdf
export const getbusinessNo = p => post(`/${name2}/way/getbusinessNo`, p) // 运单详情
export const getListWayByOrderNo = p => post(`/${name2}/api/getListWayByOrderNo`, p) // 订单详情
// 车队端-运费出入
export const sOrderList = p => post(`/${name2}/sOrder/list`, p) // 订单详情

// 用户钱包-提现管理
export const tWithdrawalInfoList = p => post(`/${payName}/tWithdrawalInfo/list`, p) // 主数据
export const tWithdrawalInfoUpdate = p => post(`/${payName}/tWithdrawalInfo/update`, p) // 确认提现
export const tWithdrawalInfoUpdateData = p => post(`/${payName}/tWithdrawalInfo/updateData`, p) // 修改
export const bPayDictionaryUploadFile = p => post(`/${payName}/bPayDictionary/uploadFile`, p) // 图片上传接口
// 充值管理
export const tRechargeInfoList = p => post(`/${payName}/tRechargeInfo/list`, p) // 充值管理-银行卡
export const listAllCustomer = p => post(`/${payName}/tAccountCustinfo/listAllCustomer`, p) // 充值管理-银行卡
export const tRechargeInfoAdd = p => post(`/${payName}/tRechargeInfo/add`, p) // 充值管理-银行卡-新增1
export const tRechargeInfoDelete = p => post(`/${payName}/tRechargeInfo/delete`, p) // 充值管理-银行卡-删除
export const tRechargeInfoUpdateStatus = p => post(`/${payName}/tRechargeInfo/updateStatus`, p) // 充值管理-银行卡-充值到账
export const tRechargeInfoUpdate = p => post(`/${payName}/tRechargeInfo/update`, p) // 充值管理-银行卡-修改
export const getPayDetailByPC = p => post(`/${payName}/tAccountCustinfo/getPayDetailByPC`, p) // 获取登陆信息
// 提现申请-批量确认提现
export const updateForList = p => post(`/${payName}/tWithdrawalInfo/updateForList`, p) // 提现申请-确认提现
// 提现记录-列表
export const recordList = p => post(`/${payName}/tBatchWithdrawal/list`, p) // 提现记录-列表
// 提现记录-修改
export const updateDataForList = p => post(`/${payName}/tWithdrawalInfo/updateDataForList`, p)
// 控货一级二级下拉(梁)
export const customerList = p => post(`/${name}/t/goods/control/master/customerList`, p)
// 控货一级二级客户控货配置列表(梁)
export const getMasterAndSummaryList = p => post(`/${name}/t/goods/control/master/getMasterAndSummaryList`, p)
// 控货明细列表（贾）
export const SVCRlist = p => post(`/${name}/sVirtualControlRecord/list`, p)
// 控货指令列表（贾）
export const controlList = p => post(`/${name}/sVirtualControl/controlList`, p)
// 控货补单（贾）
export const SVCRupdate = p => post(`/${name}/sVirtualControlRecord/update`, p)
// 控货补单（贾）
export const SVCRadd = p => post(`/${name}/sVirtualControlRecord/add`, p)
// 控货指令统计（贾）
export const controlSum = p => post(`/${name}/sVirtualControlRecord/controlSum`, p)
// 控货指令统计（贾）
export const openCloseControl = p => post(`/${name}/sVirtualControlRecord/openCloseControl`, p)

// OMS货主端
// 签章管理-验证码
export const signatureApplySmsCheck = p => post(`/${name}/signatureApply/smsCheck`, p)
// 签章管理-申请签章
export const signatureApplyAdd = p => post(`/${name}/signatureApply/add`, p)
// 签章管理-查看
export const signatureApplyDetail = p => post(`/${name}/signatureApply/detail`, p)
// 签章管理-列表  平台用章管理-签章数量
export const signatureApplyList = p => post(`/${name}/signatureApply/list`, p)
// 签章管理-删除
export const signatureApplyDelete = p => post(`/${name}/signatureApply/delete`, p)
// 用章记录(平台/货主端)
export const signatureRecordList = p => post(`/${name}/signatureRecord/list`, p)
// 平台-用章管理列表
export const signatureApplyPtList = p => post(`/${name}/signatureApply/pingtaiList`, p)

// OCR识别
// 标签管理列表
export const cOcrModelLabelList = p => post(`/${name}/cOcrModelLabel/list`, p)
// 标签添加
export const cOcrModelLabelAdd = p => post(`/${name}/cOcrModelLabel/add`, p)
// 标签删除
export const cOcrModelLabelDelete = p => post(`/${name}/cOcrModelLabel/delete`, p)
// 解析方法列表
export const cOcrModelMethodList = p => post(`/${name}/cOcrModelMethod/list`, p)
// 添加解析方法
export const cOcrModelMethodAdd = p => post(`/${name}/cOcrModelMethod/add`, p)
// 删除解析方法
export const cOcrModelMethodDelete = p => post(`/${name}/cOcrModelMethod/delete`, p)
// 模板管理列表
export const cOcrModelList = p => post(`/${name}/cOcrModel/list`, p)
// 添加模板
export const cOcrModelAdd = p => post(`/${name}/cOcrModel/add`, p)
// 删除模板
export const cOcrModelDelete = p => post(`/${name}/cOcrModel/delete`, p)
// 修改模板
export const cOcrModelUpdate = p => post(`/${name}/cOcrModel/update`, p)
// 添加模板 解析方法
export const methodList = p => post(`/${name}/cOcrModelMethod/methodList`, p)
// 添加模板 关联标签
export const labelList = p => post(`/${name}/cOcrModelLabel/labelList`, p)
// 示例图片
// export const checkExampleImage = p => post(`/${name}/cOcrModel/checkExampleImage`, p)
// 修改调取
export const cOcrModelDetail = p => post(`/${name}/cOcrModel/detail`, p)
// 支出结算-推送T+
export const getDicFromTms = p => post(`/${payName}/api/getDicFromTms`, p) // #推送哪个T+系统下拉框查询接口
// 推送T+系统确定 - 支出结算
export const pushTPlusToTmsPay = p => post(`/${payName}/downstreamSettlement/pushTPlusToTmsPay`, p)
// 推送T+系统确定 - 收入结算
export const pushTPlusToTmsCollection = p => post(`/${payName}/upstreamSettlement/pushTPlusToTmsCollection`, p)
// 代开合同列表
export const driverAgreementList = p => post(`/${name}/driverAgreement/list`, p)
// 代开合同——批量下载
export const downLoadZip = p => post(`/${name}/driverAgreement/downLoadZip`, p)

// 兼容承运合同查看pdf -王
export const getContractPdfForBusinessNoCopy = p => post(`/${name}/api/contractSignature/getContractLookPdfForBusinessNo`, p) // 查看pdf
